<h3 mat-dialog-title>Detalles de la fase</h3>

<mat-dialog-content [formGroup]="form">
  <div class="container">
    <div class="row">
      <div class="col-12 col-lg-6">
        <mat-label>Tipo de fase</mat-label>
        <mat-form-field appearance="outline">
          <mat-select formControlName="company_product_phase_type_id">
            @for (type of company_product_phase_types; track type.id) {
              <mat-option [value]="type.id">{{ type.name }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-12 col-lg-6">
        <mat-label>Estado</mat-label>
        <mat-form-field appearance="outline">
          <mat-select formControlName="company_product_phase_stage_id">
            @for (pps of company_product_phase_stages; track pps) {
              <mat-option [value]="pps.id">{{ pps.title }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-12 col-lg-6">
        <mat-label>Equipo aprobador de tareas</mat-label>
        <mat-form-field appearance="outline">
          <mat-select formControlName="company_product_team_id">
            <mat-option [value]="null">Sin asignar</mat-option>
            @for (companyProductTeam of company_product_teams; track companyProductTeam.id) {
              <mat-option [value]="companyProductTeam.id">{{ companyProductTeam.name }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-12">
        <mat-checkbox formControlName="enable_roadmap">Activar Roadmap</mat-checkbox>
      </div>
      <div class="col-12 col-lg-6" style="margin-top: 20px">
        <div class="row">
          <label>Horas requeridas</label>
          <div class="col-12">
            <mat-checkbox formControlName="needs_hours_story">
              <img [src]="'story' | productTaskTypeImage" alt="Stories" width="20" />
              Requiere horas en Stories
            </mat-checkbox>
          </div>
          <div class="col-12">
            <mat-checkbox formControlName="needs_hours_task">
              <img [src]="'task' | productTaskTypeImage" alt="Tasks" width="20" />
              Requiere horas en Tasks
            </mat-checkbox>
          </div>
          <div class="col-12">
            <mat-checkbox formControlName="needs_hours_issue">
              <img [src]="'issue' | productTaskTypeImage" alt="Issues" width="20" />
              Requiere horas en Issues
            </mat-checkbox>
          </div>
        </div>
      </div>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button color="transparent" (click)="onCancel()">Cancelar</button>
  <button mat-flat-button color="accent" (click)="save()" [disabled]="!form.valid" type="submit">Guardar</button>
</mat-dialog-actions>
